import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { IoOpenOutline } from 'react-icons/io5'

import { originalIndicator } from '../templates/blog-post.module.css'

const imageSelector = '.gatsby-resp-image-image'
const originalLinkSelector = '.gatsby-resp-image-link'
const originalIndicatorAttribute = 'data-original-indicator'
const originalLinkDisabledAttribute = 'data-original-link-disabled'
const originalIconMarkup = renderToStaticMarkup(<IoOpenOutline aria-hidden="true" focusable="false" />)

let animationFrame

const getImages = () => Array.from(document.querySelectorAll(imageSelector))

/** gatsby-resp-imageが生成する最適化画像群から最大（オリジナル画像）の幅を取得する． */
const getOriginalWidth = image => {
  const widths = Array.from((image.srcset || '').matchAll(/\s(\d+)w(?:,|$)/g), match => Number(match[1]))
  return Math.max(image.naturalWidth, ...widths)
}

/** オリジナル画像と比べて縮小表示されている場合trueを返す． */
const isReduced = image => image.complete && getOriginalWidth(image) > image.getBoundingClientRect().width

/**
 * オリジナルサイズで表示されている場合に，
 * gatsby-resp-imageが生成するオリジナル画像へのaタグを無効化する．
 */
const updateOriginalLink = (image, reduced) => {
  const originalLink = image.closest(originalLinkSelector)
  if (!originalLink) return

  originalLink.toggleAttribute(originalLinkDisabledAttribute, !reduced)
  if (reduced) {
    image.style.cursor = 'pointer'
    originalLink.style.cursor = 'pointer'
    originalLink.removeAttribute('aria-disabled')
    originalLink.removeAttribute('tabindex')
  } else {
    image.style.cursor = 'default'
    originalLink.style.cursor = 'default'
    originalLink.setAttribute('aria-disabled', 'true')
    originalLink.tabIndex = -1
  }
}

/** 縮小表示されている場合に，オリジナル画像表示用のアイコンを追加する． */
const addOriginalIndicator = image => {
  const originalLink = image.closest(originalLinkSelector)
  if (!originalLink) return

  const indicator = document.createElement('span')
  indicator.className = originalIndicator
  indicator.setAttribute('aria-hidden', 'true')
  indicator.setAttribute(originalIndicatorAttribute, '')
  indicator.innerHTML = originalIconMarkup
  originalLink.append(indicator)
}

/** 原寸リンクとアイコンの表示要否を更新する． */
const updateOriginalImageIndicators = () => {
  animationFrame = undefined
  document.querySelectorAll(`[${originalIndicatorAttribute}]`).forEach(indicator => indicator.remove())

  getImages().forEach(image => {
    const reduced = isReduced(image)
    updateOriginalLink(image, reduced)
    if (reduced) addOriginalIndicator(image)
  })
}

const scheduleOriginalImageIndicatorUpdate = () => {
  if (animationFrame !== undefined) return
  animationFrame = window.requestAnimationFrame(updateOriginalImageIndicators)
}

const watchPendingImages = () => {
  getImages()
    .filter(image => !image.complete)
    .forEach(image => image.addEventListener('load', scheduleOriginalImageIndicatorUpdate, { once: true }))
}

export const initializeOriginalImageIndicators = () => {
  window.addEventListener('resize', scheduleOriginalImageIndicatorUpdate)
}

export const updateOriginalImageIndicatorsForRoute = () => {
  watchPendingImages()
  scheduleOriginalImageIndicatorUpdate()
}
